import guestsRoutes from './guests.routes';

import arrivalDashboardComponent from './components/arrival.dashboard.component';
import arrivalListComponent from './components/arrival.list.component';

import arrivalDashboardController from './controllers/arrival.dashboard.controller';
import arrivalListController from './controllers/arrival.list.controller';

let guestsModule = angular.module('spabooker.guests', ['spabooker.base'])
    .config(guestsRoutes)

    .controller('arrivalDashboardController', arrivalDashboardController)
    .controller('arrivalListController', arrivalListController)

    .component('arrivalDashboard', arrivalDashboardComponent)
    .component('arrivalList', arrivalListComponent)
    ;

export default guestsModule.name;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/guests/index.js